<template>
  <div>
    <b-button class="float-right" v-b-modal:create-config-inocuidad> Crear </b-button>
    <b-modal id="create-config-inocuidad" title="Hey!" @ok="handleOk">
      <b-form>
        <!-- Form for label, inputType and inputOptions -->
        <b-form-group label="Nombre" label-for="label">
          <b-form-input id="label" v-model="form.label"></b-form-input>
        </b-form-group>
        <b-form-group label="Tipo" label-for="inputType">
          <b-form-select id="inputType" v-model="form.inputType">
            <option value="text">Text</option>
            <option value="select">Select</option>
          </b-form-select>
        </b-form-group>
        <b-form-group label="Key">
          <b-form-input disabled :value="slugLabel"></b-form-input>
        </b-form-group>
        <b-form-group label="Opciones" v-if="form.inputType === 'select'">
          <b-input-group class="mb-2" v-for="(opt, optIndex) in form.inputOptions" :key="optIndex">
            <b-form-input v-model="opt.label" placeholder="Sí / No / Aprobado / R / ..."></b-form-input>
            <b-form-select v-model="opt.color" :options="colors"></b-form-select>
            <b-input-group-append v-if="isDisabled(optIndex)">
              <b-button size="sm" text="Button" variant="danger" @click.prevent="removeItem(optIndex)"
                ><i class="fa fa-lg fa-trash"></i
              ></b-button>
            </b-input-group-append>
          </b-input-group>
          <b-button size="sm" text="Button" variant="success" @click.prevent="addOption"
            ><i class="fa fa-lg fa-plus"></i
          ></b-button>
        </b-form-group>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
export default {
  name: "CreateConfig",
  data() {
    return {
      form: {
        label: null,
        inputType: null,
        inputOptions: []
      },
      colors: [
        {
          text: "Sin color",
          value: null
        },
        {
          text: "Rojo",
          value: "danger"
        },
        {
          text: "Verde",
          value: "success"
        },
        {
          text: "Amarillo",
          value: "warning"
        },
        {
          text: "Azul",
          value: "primary"
        }
      ]
    };
  },
  validations: {
    form: {
      label: {
        required
      },
      inputType: {
        required
      }
    }
  },
  watch: {
    "form.inputType": function (val) {
      if (val === "select") {
        this.form.inputOptions = [
          {
            label: null,
            color: null
          }
        ];
      } else {
        this.form.inputOptions = [];
      }
    }
  },
  methods: {
    handleOk() {
      const payload = {
        label: this.form.label,
        key: this.slugLabel,
        inputType: this.form.inputType,
        inputOptions: this.form.inputOptions
      };
      this.$emit("create-config", payload);
    },
    addOption() {
      this.form.inputOptions.push({
        label: null,
        color: null
      });
    },
    isDisabled(index) {
      // Check if the option is the last one
      return this.form.inputOptions.length - 1 !== index;
    },
    removeItem(index) {
      this.form.inputOptions.splice(index, 1);
    }
  },
  computed: {
    slugLabel() {
      let result = "";
      if (this.form.label) {
        result = this.form.label.replace(/ /g, "_").toLowerCase();
      }
      return result;
    }
  }
};
</script>

<style></style>
